import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingCartIcon, ZapIcon } from 'lucide-react';
export function UniqueMechanism() {
  return <section className="py-24 px-4 bg-stone-900 text-white overflow-hidden relative" data-id="element-174">
      <div className="absolute top-0 right-0 w-96 h-96 bg-brand-accent/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-175"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-brand-green/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-176"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-177">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-178">
          <div className="inline-flex items-center gap-2 bg-brand-accent/20 text-brand-accent px-4 py-2 rounded-full text-sm font-bold tracking-wide uppercase mb-6" data-id="element-179">
            <ZapIcon className="w-4 h-4" data-id="element-180" /> El Secreto
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl mb-6" data-id="element-181">
            La Regla de los 3 Bloques
          </h2>
          <p className="text-2xl text-stone-300 font-serif italic" data-id="element-182">
            Proteína + Fibra + Saciador
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-183">
          {[{
          title: 'Proteína',
          color: 'bg-red-500/20 text-red-300 border-red-500/30',
          desc: 'Pre-cocida o de cocción ultra rápida'
        }, {
          title: 'Fibra',
          color: 'bg-green-500/20 text-green-300 border-green-500/30',
          desc: 'Vegetales listos para usar'
        }, {
          title: 'Saciador',
          color: 'bg-amber-500/20 text-amber-300 border-amber-500/30',
          desc: 'Carbohidratos inteligentes'
        }].map((block, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.15
        }} className={`p-8 rounded-2xl border ${block.color} text-center backdrop-blur-sm`} data-id="element-184">
              <h3 className="text-2xl font-bold mb-3 font-sans" data-id="element-185">
                {block.title}
              </h3>
              <p className="opacity-80" data-id="element-186">{block.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="bg-white/5 border border-white/10 p-8 md:p-10 rounded-3xl backdrop-blur-md text-center max-w-3xl mx-auto" data-id="element-187">
          <h3 className="text-3xl mb-6 font-serif" data-id="element-188">
            Olvídate de "cocinar" desde cero. Este sistema te enseña a
            ENSAMBLAR.
          </h3>
          <p className="text-lg text-stone-300 leading-relaxed mb-8" data-id="element-189">
            Usamos la inteligencia del supermercado (
            <span className="text-white font-bold" data-id="element-190">Walmart, Aldi, Costco</span>)
            a tu favor, combinando ingredientes base de alta calidad que ya
            vienen pre-listos.
          </p>
          <div className="inline-flex items-center justify-center gap-3 bg-brand-accent text-white px-6 py-3 rounded-xl font-bold text-lg" data-id="element-191">
            <ShoppingCartIcon className="w-6 h-6" data-id="element-192" />
            Nutrición Mecánica
          </div>
          <p className="mt-6 text-stone-400" data-id="element-193">
            En 15 minutos exactos, la cena está en la mesa, es deliciosa y no
            hay casi nada que lavar.
          </p>
        </motion.div>
      </div>
    </section>;
}